var $8d15e736e12d3dfd$exports = {};
$8d15e736e12d3dfd$exports = {
  "breadcrumbs": "\u5BFC\u822A\u680F"
};
export { $8d15e736e12d3dfd$exports as default };